// tslint:disable:max-line-length

import React from 'react';

export const LogoOpengovWand = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="157.01 204.13 765.98 671.75" {...props}>
      <path d="M891.57 204.13H188.44c-32.1 0-43.49 42.5-15.69 58.55l335.87 193.91v387.86c0 32.1 42.5 43.49 58.55 15.69l351.57-608.95c12.08-20.92-3.02-47.06-27.17-47.06Z" />
    </svg>
  );
};
